import { render, staticRenderFns } from "./Judging.vue?vue&type=template&id=b4a22922&scoped=true&"
import script from "./Judging.vue?vue&type=script&lang=js&"
export * from "./Judging.vue?vue&type=script&lang=js&"
import style0 from "./Judging.vue?vue&type=style&index=0&id=b4a22922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a22922",
  null
  
)

export default component.exports